import { Component, ElementRef, Input, OnDestroy, Output } from '@angular/core';
import { asyncScheduler, BehaviorSubject, Subscription } from 'rxjs';
import { TableRecsAction } from './table-view-action';

// TODO - refactor this to just a single row action picker since it is confusing
//        how it works for both row actions or bulk actions on multiple rows
@Component({
  selector: 'fes-table-view-action-picker',
  templateUrl: `./table-view-action-picker.component.html`
})
export class TableViewActionPickerComponent<RecordType> implements OnDestroy{
  @Input() checkedRowCnt: number;
  @Input() recs: RecordType[];
  @Input() table: { errorMsg: string }; // just need access to set errorMsg for now (don't want circular dependency)
  actionSubs: Subscription[] = [];

  @Input('rowActions') set rowActionsSet(actions: TableRecsAction<RecordType>[]) {
    this.actionSubs?.forEach(sub => sub.unsubscribe());
    this.rowActions = actions;
    // detect when another picker is processing same records
    this.actionSubs = actions?.map(action => action.running$.subscribe(runningRecs => {
      if ( !this.isProcessing$.value ) {
        // something else is processing the records
        this.isPeerProcessingAll = runningRecs?.length && this.recs?.length && this.recs.every(r=>runningRecs.includes(r))
        this.activeAction = this.isPeerProcessingAll ? action : null
      } else {
        this.isPeerProcessingAll = false
      }
    }));
  }

  rowActions: TableRecsAction<RecordType>[];
  @Input() title = 'Actions';
  @Output('isProcessing') isProcessing$ = new BehaviorSubject<boolean>(false)

  activeAction: TableRecsAction<RecordType> | null;
  isPeerProcessingAll = false;
  tableRowElement : HTMLTableRowElement;

  constructor(
    private elementRef:ElementRef
  ){

  }

  ngOnDestroy(): void {
    this.actionSubs?.forEach(as=>as.unsubscribe())
  }

  onDropdownShown() {
    this.tableRowElement = this.elementRef?.nativeElement.closest('tr')
    const trEl = this.tableRowElement
    if ( trEl ) {
      trEl.classList.add('choose-action-row')
      asyncScheduler.schedule( () => {
        const ulEl = document.querySelector('body > bs-dropdown-container .dropdown.open.show .dropdown-menu')
        ulEl?.scrollIntoView({behavior: 'smooth', block: 'center'})
      })
    }
  }

  onDropdownHidden() {
    this.tableRowElement?.classList.remove('choose-action-row')
    this.tableRowElement = null
  }

  async doAction(action: TableRecsAction<RecordType>) {
    this.isProcessing$.next(true)
    this.activeAction = action

    const trEl = this.elementRef?.nativeElement.closest('tr')
    trEl?.classList.remove('choose-action-row')

    try {
      this.table.errorMsg = null
      const result = await action.recsAction({recs:this.recs,action});
      console.log(JSON.stringify(result))
      this.table.errorMsg = result.ok ? null : result.msg
    } catch (error: any) {
      const msg = error?.message ||`${error?.message}`
      this.table.errorMsg = msg
    } finally {
      this.activeAction = null
      this.isProcessing$.next(false)
    }
  }
}
